import { ProductImageGallery } from '../product/product-image-gallery';
import { TopInfo } from '../product/top-info';
import React, { FC } from 'react';
import { ProductPageQuery } from '../../@types/codegen/graphql';
import styles from './detail-information.module.scss';

type DetailInformationProps = {
  productBundle: ProductPageQuery['productBundle'];
}

export const DetailInformation: FC<DetailInformationProps> = ({ productBundle }) => {
  return (
    <div className={styles.detailInformation}>
      <section className={styles.detailInformationGrid}>
        <div className={styles.gallery}>
          <ProductImageGallery
            images={productBundle?.bundle?.selectedProduct?.productImages ?? productBundle?.bundle?.type.images ?? []}
          />
        </div>

        <div className={styles.propertiesList}>
          {productBundle && <TopInfo
            productBundle={productBundle}
          />}
        </div>
      </section>
    </div>
  );
};
